import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components'
import dayjs from 'dayjs';
import * as api from '../../api';
import Spinner from '../../Plateforme/Atoms/Spinner';
import BlueButton from '../Atoms/BlueButton';
import Searchbar from './Searchbar';
import { NeedToPay, IsExpiringSoon } from '../Utils/Validator';
import PaymentPopup, { PaymentPopupV2 } from './PaymentPopup';

const Container = styled.div`
    width: 100%;
    margin: 0;
    background-color: white;
    position: relative;
    border-bottom: 1px solid black;
    display: flex;
    justify-content: center;
`

const InnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-left: 10px;
    padding-left: 100px;
    flex-grow: 1;
    height: 77px;

    @media (max-width: 1000px) or (max-height: 660px) {
        padding-left: 10px;
    }

    @media (max-width: 1000px){
        padding-left: 0;
    }

    .flexblock {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    img {
        width: 150px;
        padding-right: 20px;

        @media (max-width: 1000px) {
            padding-left: 0;
        }

        /* hide topbar logo when the sidebar is displayed (screen width > 1000px && height > 660px) */
        @media (min-width: 1001px) and (min-height: 661px) {
            display: none;
        }
    }

    .menuLink {
        padding: 0 15px;
        text-decoration: none;
        color: black;
        font-weight: 500;
        font-size: 18px;

        @media (max-width: 1500px) {
            padding: 0 8px;
            font-size: 14px;
        }

        &:hover {
            color: blue;
        }
    }

    .dropdown {
        position: relative;
        font-weight: 500;
        min-width: 200px;
        border-left: 1px solid black;
        border-right: 1px solid black;
        height: 100%;
        display: flex;
        align-items: center;


        .dropbtn {
            padding: 28px 15px;
            /*background-color: #f4f4f4;*/
            background-color: white;
            color: blue;
            text-transform: uppercase;
            display: block;
            width: 100%;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
                /* background-color: #ddd; */
                background-color: #f4f4f4;
                cursor: pointer;
            }

            .name_inner {
                display: inline-block;
                margin-right: 10px;

                /* no wrap, overflow as ellipsis */
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 260px;
            }
        }

        .dropdown-content {
            position: absolute;
            background-color: #f4f4f4;
            width: calc(100% + 2px);
            z-index: 99;
            left: -1px;
            top: 78px;

            a, span {
                cursor: pointer;
                color: black;
                padding: 28px 30px;
                text-decoration: none;
                display: block;
                border-bottom: 1px solid black;
                border-left: 1px solid black;
                border-right: 1px solid black;

                &:hover {
                    background-color: #ddd;
                }
            }
        }
    }

    form {
        position: relative;
        
        input {
            width: 100%;
            border: 0;
            padding: 18px 0;
            margin: 0;
            outline: none;
            background-color: transparent;
            font-size: 22px;
            font-weight: 600;

            ::placeholder {
                color: blue;
            }
        }

        img {
            display: ${props => props.searchFieldContent ? "none" : "block"};
            width: 25px;
            padding: 0;
            margin: 0;
            position: absolute;
            left: ${props => props.lang === "fr" ? "130px" : "80px"};
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;

            @media (max-width: 1000px) or (max-height: 660px) {
                display: none;
            }
        }

        img.loupe-mobile {
            display: none;

            @media (max-width: 1000px) or (max-height: 660px) {
                display: block;
                right: 10px;
                left: unset;
                pointer-events: all;
                cursor: pointer;
            }
        }
    }
`

const TranslateContainer = styled.div`
    margin: 0 20px;

    @media (max-width: 1500px) {
        margin: 0;
    }
`

const LanguageButton = styled.span`
    margin: 5px;
    display: inline-block;
    text-decoration: none;
    font-weight: 500;

    &.active {
        text-decoration: underline;
    }
`

function TranslateButton() {

    async function changeLanguage(lang) {
        i18n.changeLanguage(lang);
        dayjs.locale(lang);
        api.SwitchUserLang({lang : lang});
    }

    const {i18n} = useTranslation('common');

    return <div>
        <LanguageButton className={'linkbutton' + (i18n.language === "fr" ? ' active' : '')} onClick={() => changeLanguage('fr')} >Fr</LanguageButton>
        <LanguageButton className={'linkbutton' + (i18n.language === "en" ? ' active' : '')} onClick={() => changeLanguage('en')} >En</LanguageButton>
    </div>
}

const MobileMenuContainer = styled.div`
    position: fixed;
    top: 78px;
    left: 0;
    background-color: white;
    width: 100%;
    height: calc(100vh - 78px);
    z-index: 6;
    padding: 20px;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;

    > * , > a{
        font-size: 20px;
        font-weight: 500;
        padding: 10px 0;
        text-decoration: none;
        color: black;
        cursor: pointer;
    }
`;

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc',
    '67a0b8331b103d938bafa954',
    '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c',
    '67e6c18043d5609350e381a8',
    '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73',
    '67bf2330b1ba28c3144af8d2',
    '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63',
    '67c6b416db48cb16a13c73c7',
    '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c',
    '67d15108d95ccf24eaf191df',
    '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e',
    '662adc507159e5b1b1da7c75',
    '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2',
    '682b5c5f754f51df2ef93bbc',
    '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb',
    '67daebf343d5609350e27a9e',
    '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360',
    '67e1452a43d5609350e2b066',
    '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97',
    '67e3e1cb43d5609350e304e5',
    '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a',
    '67e42d7043d5609350e32539',
    '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0',
    '67e529f743d5609350e33a8c',
    '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f',
    '67e5764d43d5609350e34cb5',
    '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3',
    '67e58da443d5609350e3561d',
    '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905',
    '67e6828d43d5609350e36b6a',
    '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667',
    '67e6c0a843d5609350e380cf',
    '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900',
    '67e7003c43d5609350e38bfc',
    '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae',
    '67f90250a0262e085d37088f',
    '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e',
    '67ab6ade07736060460b3c16',
    '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d',
    '6800b8529167c049fff50e47',
    '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f',
    '6800fad59167c049fff52224',
    '680113739167c049fff52d73',
    '680106139167c049fff525af',
    '680125219167c049fff53405',
    '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e',
    '68020ef79167c049fff54015',
    '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7',
    '680249249167c049fff55a19',
    '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037',
    '680270379167c049fff566f5',
    '680274c09167c049fff567c8',
    '680275419167c049fff567de',
    '68027b389167c049fff56954',
    '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f',
    '6849787b17dde4ca4c4bf043',
    '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4',
    '6808c3f59167c049fff599c7',
    '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee',
    '6801e2f49167c049fff53ce1',
    '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49',
    '6810df4a264e7745556ad75d',
    '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977',
    '680fa9f09167c049fff5e027',
    '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62',
    '6818cac19e656d77bc6c72fa',
    '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0',
    '682d97b2754f51df2ef96070',
    '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const is_fd100_4eme_edition_winner = (fullUser) => {
    // return false;
    if (!fullUser || !fullUser.company || !fullUser.company.projects) {
        return false;
    }

    for (let project of fullUser.company.projects) {
        if (WINNER_PROJECT_IDS.includes(project._id)) {
            return true;
        }
    }
    return false;
}

function ProfileDropdown(props) {
    const { i18n } = useTranslation('common');
    const [userName, setUserName] = useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const location = useLocation();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        function handleResize() {
            setScreenWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (props.fullUser?.hsCompany?.properties?.name) {
            setUserName(props.fullUser.hsCompany.properties.name);
        }else if (props.fullUser?.hsProfile?.firstname && props.fullUser?.hsProfile?.lastname) {
            setUserName(props.fullUser.hsProfile.firstname + " " + props.fullUser.hsProfile.lastname);
        }else if (props.fullUser?.user?.first_name && props.fullUser?.user?.last_name) {
            setUserName(props.fullUser?.user?.first_name + " " + props.fullUser?.user?.last_name);
        }else if (props.fullUser?.user?.email) {
            setUserName(props.fullUser?.user?.email);
        }else {
            setUserName(i18n.language === "fr" ? "Mon compte" : "My account");
        }
        // setUserName("a bc def ghge dkejek dkejek dkejek");
    }, [props.fullUser]);

    useEffect(() => {
        setDropdownOpen(false); // Set dropdownOpen to false when the URL changes
    }, [location]);

    return (
        <div className='dropdown'>
            <span className='dropbtn' onClick={() => setDropdownOpen(!dropdownOpen)}>
                <div className='name_inner'>{userName}</div>▾
            </span>
            {dropdownOpen &&
                <div className='dropdown-content'>
                    {(!props.fullUser.user?.role || props.fullUser.user?.role === 'guest') && <>
                        <Link to='/mydashboard'>{i18n.language === "fr" ? "Mon espace" : "My space"}</Link>
                        <Link to='/myprofile'>{i18n.language === "fr" ? "Mon profil" : "My profile"}</Link>
                        {props.fullUser.company?._id ? <>
                            <Link to={props.fullUser.company?.ownerUserId === props.fullUser.user._id ? '/mycompany' : '/company?id=' + props.fullUser.company._id}>{i18n.language === "fr" ? "Ma société" : "My company"}</Link>
                            <Link to={props.fullUser.company?.ownerUserId === props.fullUser.user._id ? '/mycompany?snap_to_projects=true' : '/company?id=' + props.fullUser.company._id + '&snap_to_projects=true'}>{i18n.language === "fr" ? "Mes projets" : "My projects"}</Link>
                        </>:
                            <Link to={'/mycompany'}>{i18n.language === "fr" ? "Créer ma société" : "Create my company"}</Link>
                        }
                        <Link to='/mycandidatures'>{i18n.language === "fr" ? "Mes candidatures" : "My applications"}</Link>
                        {is_fd100_4eme_edition_winner(props.fullUser) && <Link to='/mywinningprojects'>{i18n.language === "fr" ? "Lauréat" : "Winner"}</Link>}
                    </>}
                    {props.fullUser.user?.role === "admin" && <>
                        <Link to='/mywinningprojects'>{i18n.language === "fr" ? "Lauréat (Preview)" : "Winner (Preview)"}</Link>
                        <Link to='/annuaireadmin'>{i18n.language === "fr" ? "Annuaire" : "Directory"}</Link>
                        {/* <Link to='/admin/profiles'>{i18n.language === "fr" ? "Profils" : "Profiles"}</Link>
                        <Link to='/admin/companies'>{i18n.language === "fr" ? "Sociétés" : "Companies"}</Link>
                        <Link to='/admin/projects'>{i18n.language === "fr" ? "Projets" : "Projects"}</Link> */}
                        <Link to='/admin/events'>{i18n.language === "fr" ? "Évènements" : "Events"}</Link>
                        <Link to='/admin-worldmap'>{i18n.language === "fr" ? "Worldmap" : "Worldmap"}</Link>
                        <Link to='/admin/cdc'>{i18n.language === "fr" ? "Cahiers de Style" : "Cahiers de Style"}</Link>
                        <Link to='/admin/monitoring'>{i18n.language === "fr" ? "Monitoring" : "Monitoring"}</Link>
                    </>}
                    {props.fullUser.user?.role === "jury" && <>
                        <Link to='/fdjury'>{i18n.language === "fr" ? "Interface jury" : "Jury interface"}</Link>
                    </>}
                    {screenWidth <= 1300 && props.showDevenirMembre &&
                        <span onClick={props.onDevenirMembreClick}>{props.isRenewal ? (i18n.language === "fr" ? "Renouveler" : "Renew membership") : (i18n.language === "fr" ? "Devenir membre" : "Pay membership fees")}</span>
                    }
                    <span onClick={props.logout}>{i18n.language === "fr" ? "Se déconnecter" : "Logout"}</span>
                </div>
            }
        </div>
    );
}

const SidebarContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 90px;
    height: 100vh;
    background-color: white;
    z-index: 5;
    border-right: 1px solid black;

    @media (max-width: 1000px) or (max-height: 660px) {
        display: none;
    }

    .innerContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: calc(100% - 140px);
    }

    span {
        writing-mode: vertical-lr;
        transform: rotate(-180deg);
        display: block;
        padding: 20px 0;
        font-weight: 500;
        text-decoration: none;
        color: black;
        //text-transform: uppercase;
    }

    .sidelink {
        border: 1px solid black;
        border-radius: 100px;
        padding: 15px 5px;
        margin: 8px 0;
        cursor: pointer;
        &.active {
            color: white;
            background-color: black;
        }

        @media (max-height: 800px) {
            padding: 10px 5px;
            margin: 5px 0;
            font-size: 12px;
        }
    }

    .annuaireButton {
        font-size: 40px;
        margin: 0;
    }

`

const Navigation = (props) => {

    const {i18n} = useTranslation('common');

    const location = useLocation();
    const navigate = useNavigate();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [mobileMenuOpened, setMobileMenuOpened] = useState(false);
    const [PaymentPopupOpen, setPaymentPopupOpen] = React.useState(false);

    useEffect(() => {
        function handleResize() {
            setScreenWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setMobileMenuOpened(false); // Set mobileMenuOpened to false when the URL changes
    }, [location]);

    const showSideIndicators = location.pathname.includes('/project') || location.pathname.includes('/company') || location.pathname.includes('/profile');

    function logout() {
        console.log("logout")
        api.Logout().then(() => {
            props.refreshUser();
            navigate('/login');
        }).catch((error) => {
            console.log(error);
        });
    }

    //while the mobile menu is open, the only scrollable part is the mobile menu
    useEffect(() => {
        //scroll to the top
        window.scrollTo(0, 0);
        if (mobileMenuOpened) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [mobileMenuOpened]);

    return (
        <>
            {PaymentPopupOpen && props.fullUser && <PaymentPopupV2 close={() => setPaymentPopupOpen(false)} email={props.fullUser?.hsProfile?.email}/>}
            <Container>
                <InnerContainer>
                    <div className='flexblock'>
                        <Link to='/'><img src='/img/LogosV3.png' alt='Le FRENCH DESIGN'/></Link>
                        {screenWidth > 1000 && <Link style={{paddingLeft:"0"}} className='menuLink' to='/annuaire'>{i18n.language === "fr" ? "L'annuaire" : "Directory"}</Link>}
                        {screenWidth > 1000 && props.fullUser && <Link className='menuLink' to='/evenements'>{i18n.language === "fr" ? "Vos évènements" : "Your events"}</Link>}
                        {screenWidth > 1000 && props.fullUser && <Link className='menuLink' to='/actualités'>{i18n.language === "fr" ? "Actualités" : "News"}</Link>}
                        {screenWidth > 1000 && <Link className='menuLink' to='/worldmap'>{i18n.language === "fr" ? "Worldmap" : "Worldmap"}</Link>}
                        {screenWidth > 1000 && <Link className='menuLink' to='/fd100'>Le FD100</Link>}
                        {screenWidth > 1000 && <Link className='menuLink' to='/apropos'>{i18n.language === "fr" ? "À Propos" : "About"}</Link>}
                    </div>
                    {screenWidth > 1000 && <div className='flexblock'>
                        {screenWidth > 1300 && props.fullUser && (NeedToPay(props.fullUser.hsProfile) || IsExpiringSoon(props.fullUser.hsProfile)) &&
                            <BlueButton className='button_devenir' style={{marginRight:"10px"}} onClick={e => {e.preventDefault(); setPaymentPopupOpen(true)}}  >{IsExpiringSoon(props.fullUser.hsProfile) ? (i18n.language === "fr" ? "Renouveler" : "Renew membership") : (i18n.language === "fr" ? "Devenir membre" : "Pay membership fees")}</BlueButton>
                        }
                        {props.fullUserLoading ? <Spinner/> :
                            (props.fullUser ?
                                <ProfileDropdown
                                    fullUser={props.fullUser}
                                    refreshUser={props.refreshUser}
                                    logout={logout}
                                    showDevenirMembre={NeedToPay(props.fullUser.hsProfile) || IsExpiringSoon(props.fullUser.hsProfile)}
                                    isRenewal={IsExpiringSoon(props.fullUser.hsProfile)}
                                    onDevenirMembreClick={() => setPaymentPopupOpen(true)}
                                />
                            :
                                <Link className='menuLink' to='/login'><BlueButton>{i18n.language === "fr" ? "Se connecter" : "Login"}</BlueButton></Link>
                            )
                        }
                        <TranslateContainer>
                            <TranslateButton />
                        </TranslateContainer>
                    </div>}
                    {screenWidth <= 1000 && <span onClick={() => setMobileMenuOpened(!mobileMenuOpened)} style={{fontWeight:"500",fontSize:"20px",paddingRight:"10px", cursor:"pointer"}}>MENU</span>}
                </InnerContainer>
            </Container>
            {!(['/annuaire', '/homepage', '/apropos', '/actualit%C3%A9s', '/worldmap', '/fd100', '/mycandidatures', '/forms'].some(path => location.pathname.includes(path)) || location.pathname === '/') && <Container>
                <Searchbar /> 
            </Container>}
            {mobileMenuOpened && screenWidth <= 1000 && <MobileMenuContainer>
                <Link style={{paddingTop:0}} className='menuLink' to='/annuaire'>{i18n.language === "fr" ? "L'annuaire" : "Directory"}</Link>
                <Link className='menuLink' to='/actualités'>{i18n.language === "fr" ? "Actualités" : "News"}</Link>
                <Link className='menuLink' to='/apropos'>{i18n.language === "fr" ? "À Propos" : "About"}</Link>
                <Link className='menuLink' to='/worldmap'>{i18n.language === "fr" ? "Worldmap" : "Worldmap"}</Link>
                <Link className='menuLink' to='/fd100'>Le FD100</Link>
                {props.fullUser && <Link className='menuLink' to='/evenements'>{i18n.language === "fr" ? "Vos évènements" : "Your events"}</Link>}
                {props.fullUserLoading ? <Spinner/> : 
                    (props.fullUser ? <>
                        {(!props.fullUser.user?.role || props.fullUser.user?.role === 'guest') && <>
                            <Link className='menuLink' to='/mydashboard'>{i18n.language === "fr" ? "Mon espace" : "My space"}</Link>
                            <Link className='menuLink' to='/myprofile'>{i18n.language === "fr" ? "Mon profil" : "My profile"}</Link>
                            {props.fullUser.company?._id ? <>
                                <Link to={props.fullUser.company?.ownerUserId === props.fullUser.user._id ? '/mycompany' : '/company?id=' + props.fullUser.company._id}>{i18n.language === "fr" ? "Ma société" : "My company"}</Link>
                                <Link to={props.fullUser.company?.ownerUserId === props.fullUser.user._id ? '/mycompany?snap_to_projects=true' : '/company?id=' + props.fullUser.company._id + '&snap_to_projects=true'}>{i18n.language === "fr" ? "Mes projets" : "My projects"}</Link>
                            </>:
                                <Link to={'/mycompany'}>{i18n.language === "fr" ? "Créer ma société" : "Create my company"}</Link>
                            }
                            <Link to='/mycandidatures'>{i18n.language === "fr" ? "Mes candidatures" : "My applications"}</Link>
                            {is_fd100_4eme_edition_winner(props.fullUser) && <Link to='/mywinningprojects'>{i18n.language === "fr" ? "Lauréat" : "Winner"}</Link>}
                        </>}
                        {props.fullUser.user?.role === "admin" && <>
                            <Link className='menuLink' to='/mywinningprojects'>{i18n.language === "fr" ? "Lauréat (Preview)" : "Winner (Preview)"}</Link>
                            {/* <Link className='menuLink' to='/admin/profiles'>{i18n.language === "fr" ? "Profils" : "Profiles"}</Link>
                            <Link className='menuLink' to='/admin/companies'>{i18n.language === "fr" ? "Sociétés" : "Companies"}</Link>
                            <Link className='menuLink' to='/admin/projects'>{i18n.language === "fr" ? "Projets" : "Projects"}</Link> */}
                            <Link className='menuLink' to='/annuaireadmin'>{i18n.language === "fr" ? "Annuaire" : "Directory"}</Link>
                            <Link className='menuLink' to='/admin/events'>{i18n.language === "fr" ? "Évènements" : "Events"}</Link>
                            <Link className='menuLink' to='/admin-worldmap'>{i18n.language === "fr" ? "Worldmap" : "Worldmap"}</Link>
                            <Link className='menuLink' to='/admin/cdc'>{i18n.language === "fr" ? "Cahiers de Style" : "Cahiers de Style"}</Link>
                            <Link className='menuLink' to='/admin/monitoring'>{i18n.language === "fr" ? "Monitoring" : "Monitoring"}</Link>
                        </>}
                        {props.fullUser.user?.role === "jury" && <>
                            <Link to='/fdjury'>{i18n.language === "fr" ? "Interface jury" : "Jury interface"}</Link>
                        </>}
                        <span onClick={logout}>{i18n.language === "fr" ? "Se déconnecter" : "Logout"}</span>
                    </>:
                        <Link className='menuLink' to='/login'>{i18n.language === "fr" ? "Se connecter" : "Login"}</Link>
                    )
                }
                {props.fullUser && (NeedToPay(props.fullUser.hsProfile) || IsExpiringSoon(props.fullUser.hsProfile)) &&
                    <BlueButton style={{color:"white"}} onClick={e => {e.preventDefault(); setPaymentPopupOpen(true)}} className="" >{IsExpiringSoon(props.fullUser.hsProfile) ? (i18n.language === "fr" ? "Renouveler" : "Renew membership") : (i18n.language === "fr" ? "Devenir membre" : "Pay membership fees")}</BlueButton>
                }
                <TranslateContainer>
                    <TranslateButton />
                </TranslateContainer>
            </MobileMenuContainer>}
            <SidebarContainer>
                <Link to='/'>
                    <img src='/img/LogosV4a.png' alt='Le FRENCH DESIGN' style={{padding:"13px 19px 9px"}}/>
                    <img src='/img/LogosV4b.png' alt='Le FRENCH DESIGN' style={{padding:"0 15px"}}/>
                </Link>
                <div className='innerContainer'>
                    {showSideIndicators && <>
                        <span onClick={() => navigate('/annuaire?f=' + btoa(JSON.stringify({type:'project'})))} className={'sidelink' + (location.pathname.includes('/project') ? ' active' : '')}>{i18n.language === "fr" ? "Projets" : "Projects"}</span>
                        <span onClick={() => navigate('/annuaire?f=' + btoa(JSON.stringify({type:'company'})))} className={'sidelink' + (location.pathname.includes('/company') ? ' active' : '')}>{i18n.language === "fr" ? "Sociétés" : "Companies"}</span>
                        <span onClick={() => navigate('/annuaire?f=' + btoa(JSON.stringify({type:'profile'})))} className={'sidelink' + (location.pathname.includes('/profile') ? ' active' : '')}>{i18n.language === "fr" ? "Profils" : "Profiles"}</span>
                    </>}
                    {location.pathname.startsWith('/evenements') ? (
                        <span className='annuaireButton' to='/evenements'>
                            {i18n.language === "fr" ? "ÉVÈNEMENTS" : "EVENTS"}
                        </span>
                    ) : location.pathname.startsWith('/actualit%C3%A9s') ? (
                        <span className='annuaireButton' to='/actualites'>
                            {i18n.language === "fr" ? "ACTUALITÉS" : "NEWS"}
                        </span>
                    ) : location.pathname.startsWith('/fd100') ? (
                        <span className='annuaireButton'>
                            FD100
                        </span>
                    ) : location.pathname.startsWith('/apropos') ? (
                        <span className='annuaireButton' to='/apropos'>
                            {i18n.language === "fr" ? "À PROPOS" : "ABOUT"}
                        </span>
                    ) : location.pathname.startsWith('/forms') ? (
                        <span className='annuaireButton' to='/forms'>
                            {i18n.language === "fr" ? "FORMULAIRES" : "FORMS"}
                        </span>
                    ) : location.pathname.startsWith('/presse/') ? (
                        <span className='annuaireButton'>
                            {i18n.language === "fr" ? "PRESSE" : "PRESS"}
                        </span>
                    ) : location.pathname === '/' ? (
                        <span className='annuaireButton'>
                            Le FRENCH DESIGN
                        </span>
                    ) : (
                        <span className='annuaireButton' to='/annuaire'>
                            {i18n.language === "fr" ? "ANNUAIRE" : "DIRECTORY"}
                        </span>
                    )}
                </div>
            </SidebarContainer>
        </>
    );
};

export default Navigation;